const shouldDisplaySeeAnotherDashboard = (loggedInUsername: string): boolean =>
  ['akash_sharma@zykrr.com', 'aayush_sharma@zykrr.com', 'prince_dubey@zykrr.com', 'sagar_anand@zykrr.com','lalit@zykrr.com','nandkishor_tripathi@zykrr.com','ashish_sharma@zykrr.com'].includes(
    loggedInUsername,
  ) && localStorage.getItem('primaryUser') === null

const logout = (): void => {
  localStorage.clear()
  // redirect to auth service for signout
  window.location.href = `${process.env.AUTH_HOST}/sign_out?continue=${encodeURI(
    window.location.href,
  )}`
}

export { shouldDisplaySeeAnotherDashboard, logout }
